<div class="titles-wrapper">
  <div class="title-container">
    <div class="btn-secondary-wrapper">
      <a class="btn-secondary-action" (click)="downloadTemplate()" [href]="filteringdownload"
        download="{{ filenametodownload }}">
        <img src="/assets/img/form/download.svg" class="svg-toblack" /> Descargar
      </a>
      <button type="button" class="btn-secondary-action ms-auto" (click)="fileupload.click()">
        <img src="/assets/img/form/upload.svg" class="svg-toblack" /> Subir JSON
      </button>
      <input type="file" class="input-file" #fileupload (change)="postFileOpenModal($event)"
        (click)="postFileRemove($event)" />
    </div>
  </div>
  <div class="title-container" *ngIf="fileuploaded.status === 'done' && fileuploaded.file">
    <div class="alert alert-success d-flex align-items-center" role="alert">
      <img src="/assets/img/tools/check-dark-gray.svg" class="svg-toblack" />
      <span>
        {{ fileuploaded.file.name }}
      </span>
      <img role="button" tabindex="0" src="/assets/img/tools/delete.svg" class="ms-auto cursor-pointer"
        (click)="postFileRemove()" />
    </div>
  </div>
</div>